module.exports = __webpack_public_path__ + "user.png?2a8dd743644d311089bcc2209e93c6a8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user.png
// module id = 346
// module chunks = 0